import React, { UIEvent, useEffect } from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider, MDXProviderComponents } from '@mdx-js/react';
import styled from 'styled-components';
import highlight from '../../lib/highlight';

const Wrapper = styled.div`
  .markdown {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 16px;
    line-height: 160%;
  }
  h1,
  h2,
  h3,
  h4 {
    font-weight: bold;
    margin: 20px 0 !important;
  }
  h2 {
    padding: 15px;
    margin-top: 20px !important;
    border-left: 8px solid black;
    border-bottom: 1px solid black;
    font-size: 26px;
    counter-increment: h2;
    counter-reset: h3 0;
  }
  h2:before{
    content: counter(h2) ". ";
  }
  h3{
    font-size: 22px;
    border-bottom: 1px solid black;
    padding: 7px 0;
    counter-increment: h3;
  }
  h3:before{
    content: counter(h2) "." counter(h3) ". ";
  }
  img {
    border: 1px solid black;
    display: block;
    margin: 0 auto;
  }
  .col2 {
    column-count: 2;
  }
  .col2 h4 {
    display: inline-block;
  }
  .hljs {
    background: #fafafa;
    border: 1px solid black;
    line-height: 120%;
  }
  pre { white-space:pre-wrap; }
  pre > code.language-bash,pre > code.language-cmd {
    background-color: black !important;
    color: white;
    white-space: break-spaces !important;
  }
  pre > code.language-cmd > span{color:white !important;}
  tbody, td, tfoot, th, thead, tr {
    border: 1px solid;
    padding: 5px 10px;
  }
  .gatsby-resp-image-wrapper{
    max-width: 900px !important;
  }
`;

type Props = {
  children: string
}

const components: MDXProviderComponents = {
  // 置き換えに使うコンポーネントをここに書く
}

const Markdown = (props: Props) => {
  if (typeof window !== `undefined`) {
    const url = window.location.pathname.split('/').pop();
    useEffect(() => {
      highlight();
    },[url]);
  }
  return (
    <>
      <Wrapper>
        <div className='markdown'>
          <MDXProvider components={components}>
            <MDXRenderer>{props.children}</MDXRenderer>
          </MDXProvider>
        </div>
      </Wrapper>
    </>
  );
}

export default Markdown;
